import { api } from '../config/api'

import { generateEducationalProgramFilterParams, generateFilters } from '../utils/filters'
import { defaultPageSize } from '../utils/constants'

const baseEndpoint = '/EducationalProgramApi'

export const getEducationalPrograms = () => api.get(baseEndpoint)

export const getEducationalProgramDetail = ({ id, locale }) => api.get(`${baseEndpoint}/GetByLocale/${id}`, { params: { locale } })

export const getRedirectedEducationalProgramDetail = (programUrl) => api.get(programUrl, { ignoreLocale: true })

export const requestEducationalProgramInformation = payload => api.post(`${baseEndpoint}/RequestInformation`, { ...payload, ignoreLocale: true })

export const getProgramResources = ({ programId, ...pageParams }) =>
  api.get(`${baseEndpoint}/PagedResources/${programId}`, { params: pageParams })

export const getAllFilteredPrograms = (pageNumber = 0, pageSize = defaultPageSize, filters) => {
  // TODO: Once backend has changed the way they use the values we send
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllFiltered?${params.toString()}`)
}

export const getAllCustomFilteredPrograms = (pageNumber = 0, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/Custom?${params.toString()}`)
}

export const getAllFilteredOwnedPrograms = (pageNumber = 0, pageSize = defaultPageSize, filters) => {
  // TODO: Once backend has changed the way they use the values we send
  const params = generateEducationalProgramFilterParams(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllFilteredOwned?${params.toString()}`)
}

export const getAllCustomFilteredOwnedPrograms = (pageNumber = 0, pageSize = defaultPageSize, filters) => {
  // TODO: Once backend has changed the way they use the values we send
  const params = generateEducationalProgramFilterParams(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/CustomOwned?${params.toString()}`)
}

export const getUsedContentRecords = ({ pageNumber = 0, pageSize = 5, contentId }) =>
  api.get(`${baseEndpoint}/${contentId}/UsedContentRecords`, { params: { pageNumber, pageSize } })

export const getAdminUsedContentRecords = ({ pageNumber = 0, pageSize = 5, contentId, schoolId }) =>
  api.get(`${baseEndpoint}/${contentId}/UsedContentRecords/${schoolId}`, { params: { pageNumber, pageSize } })

export const shareEducationalProgram = (data) =>
  api.post(`${baseEndpoint}/Share`, data, { params: { locale: data.locale } })

export const generateEducationalProgramPdf = ({ id, locale }) =>
  api.post(`${baseEndpoint}/${id}/GeneratePDF`, {}, { responseType: 'blob', params: { locale } })
